// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"71":"a2f7857e","256":"013d14ca","594":"d2e8ad5d","595":"7e1908d7","617":"2b034478","695":"f949e7a9","798":"2c22814c"}[chunkId] + ".js";
};